<template>
  <v-app id="inspire" :style="{ backgroundColor: bgColor }">
    <!-- <Header v-if="loginState"/>
    <Sidebar v-if="loginState"/> -->

    <AppNavigation v-if="logged" />
    <LoginPage v-else />
    <v-main>
      <v-overlay :value="isLoading" z-index="9999">
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
        ></v-progress-circular>
        <div class="mt-4 white--text">Cargando datos...</div>
      </v-overlay>
      <v-container v-if="logged" fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from "vuex";

import AppNavigation from "./components/dashboard/AppNavigation.vue";
import LoginPage from "./views/LoginPage.vue";

export default {
  components: {
    AppNavigation,
    LoginPage,
  },
  data: () => ({
    bgColor: "#f6f6f6",
  }),
  computed: {
    ...mapState({
      logged: (state) => state.user.logged,
      isLoading: (state) => state.dropdownData.isLoading,
    }),
  },

  created() {
    this.inicializar();
    if (this.$route.path !== "/login") this.$store.dispatch("user/checkLogin");
  },

  mounted() {
    // Escuchar eventos de navegación para mostrar/ocultar el loader si es necesario
    this.$router.beforeEach((to, from, next) => {
      if (this.isLoading) {
        // Si hay una carga en progreso, permitir la navegación pero mantener el loader
        next();
      } else {
        next();
      }
    });
  },
  methods:{
    async inicializar() {
      try {
        // Activar el loader
        this.$store.dispatch('dropdownData/setLoading', true);
        
        // Usar las acciones del store para cargar los datos
        await Promise.all([
          this.$store.dispatch('dropdownData/getCausas'),
          this.$store.dispatch('dropdownData/getDependencias'),
          this.$store.dispatch('dropdownData/getDepartamentales'),
          this.$store.dispatch('dropdownData/getDepartamentos'),
        ]);
        
        console.log('Todos los datos han sido cargados correctamente');
      } catch (error) {
        console.error("Error al inicializar:", error);
      } finally {
        // Desactivar el loader cuando termine, independientemente del resultado
        this.$store.dispatch('dropdownData/setLoading', false);
      }
    },
    
  }   
};
</script>

<style>
@font-face {
  font-family: "MyFont";
  src: url("./assets/fonts/BrokmanTrial-Bold.otf") format("opentype");
}
</style>
